import React from "react"
import {Icon} from "semantic-ui-react"
import settingStore from "stores/settingStore"
import ProductModelBase from "theme/base/shop/ProductModel"
import {action, observable} from "mobx"
import shop from "shop/shop"
import convertBoolean from "util/convertBoolean"

export default class ProductModelLucht extends ProductModelBase {

    @observable warning = null

    constructor(data) {
        data = convertBoolean(data)
        super(data)
        this.count = 1
        this._count = this.count

        const mode = settingStore.get("orderMode")
        const isPreorder = data.extras.vororder && data.extras.vororder !== false
        // Product from PREORDER should be available in SOFORT_ORDER
        this.available = isPreorder || (!isPreorder && mode === "MODE_AVAILABLE")

        switch (mode) {
            case "MODE_PREORDER":
                this.available = !!data.extras.vororder
                break;
            case "MODE_AVAILABLE":
                this.available = !!data.extras.sofortorder
                // this.available = Number( this.extras.varbestand ) > 0 || this.extras.orderable === true
                break;
        }

        if (this.extras.Variante === "null" || !this.extras.Variante) this.extras.Variante = "uni"
        this.extras.sale = data.extras.sale
        this.isSale = data.extras.sale
        // console.log( this.map_id, data.extras.sale, this.extras.sale, { data }, { product: this } )
    }

    validateCount(count) {
        return true
        //
        // const mode = settingStore.get( "orderMode" )
        // if ( this.extras.orderable || mode === "MODE_PREORDER" ) return true
        // if ( !this.extras.orderable ) {
        //   return this.stock >= count
        // }
    }

    set count(value) {
        this._count = value
        this.warning = this.createWarnings(value)
    }

    get count() {
        return this._count
    }


    onChange = ({count}) => {
        return this.validateCount(count)
    }

    get cartDescription() {
        return this.desc.des
    }

    /**
     *
     * @param size : Number
     * @param currentStock : Number
     * @returns {*}
     */
    getNotice = (size, currentStock = false) => {
        let product = this


        const categoryName = this.category && this.category.desc && this.category.desc.short_des.trim()

        const yellow = {}
        const red = {}

        const default_yellow = 1
        const default_red = 0

        // check special conditions
        const yellowCount = 1
        const redCount = 0

        const DEFAULT_COLOR = "grün" // TODO: this is DE coded in the API.
        const stock = currentStock || Number(this.stock) // STOCK für die Variante
        const orderMode = settingStore.get("orderMode")
        const color = this.extras.ampel || DEFAULT_COLOR
        let colorCode = "green"
        let extraText = null
        switch (color) {
            case "grün":
                colorCode = "green"
                break;
            case "rot":
                colorCode = "red"
                break;
            case "gelb":
                colorCode = "yellow"
                extraText = this.extras.nachlief ? `${translate("Lieferbar ab")}: ${this.extras.nachlief}` : ""
                break;
        }

        if (size === "tiny") {

            if (orderMode === "MODE_PREORDER") {
                return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck" title={translate("beim Lieferanten nachbestellbar")}/></span>
            }

            if (stock > yellowCount) {
                return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck" title={translate("auf Lager")}/></span>
            }

            if (product.extras.orderable || orderMode === "MODE_PREORDER") {
                return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck" title={translate("beim Lieferanten nachbestellbar")}/></span>
            }

            if (stock <= redCount && (!product.extras.orderable || orderMode !== "MODE_PREORDER")) {
                return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck" title={translate("momentan ausverkauft")}/></span>
            }

            if (stock <= yellowCount) {
                return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck" title={translate("wenige auf Lager")}/></span>
            }

            if (product.extras.orderable || orderMode === "MODE_PREORDER") {
                return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck"
                                                                       title={translate("beim Lieferanten nachbestellbar")}/></span>
            }

            return notice = <span className={"black-70 ttu"}><Icon name="truck" title="derzeit nicht lieferbar" circular/></span>
        }


        if (stock > yellowCount) {
            return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck" title="auf Lager"/> auf Lager </span>
        }

        if (product.extras.orderable || orderMode === "MODE_PREORDER") {
            return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck"
                                                                   title={translate("beim Lieferanten nachbestellbar")}/>{translate("beim Lieferanten nachbestellbar")}{extraText}</span>
        }

        if (stock <= redCount && (!product.extras.orderable || orderMode !== "MODE_PREORDER")) {
            return notice =
                <span className={"black-70 ttu"}><Icon color={colorCode} name="truck" title={translate("momentan ausverkauft")}/>{translate("momentan ausverkauft")} {extraText}</span>
        }

        if (stock <= redCount && (!product.extras.orderable || orderMode === "MODE_PREORDER")) {
            return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck"
                                                                   title={translate("beim Lieferanten nachbestellbar")}/>{translate("beim Lieferanten nachbestellbar")}{extraText}</span>
        }

        if (stock <= yellowCount) {
            return notice = <span className={"black-70 ttu"}><Icon color={colorCode} name="truck" title={translate("wenige auf Lager")}/>{translate("wenige auf Lager")}</span>
        }

        let notice = <span className={"black-70 ttu"}><Icon name="truck" title={translate("derzeit nicht lieferbar")} circular/><span>{translate("derzeit nicht lieferbar")} {extraText}</span></span>

        return notice
    }

}



// WEBPACK FOOTER //
// ./src/theme/lucht/shop/ProductModel.js